import { render, staticRenderFns } from "./SubDivisionBacklog-Column.vue?vue&type=template&id=9496fd14&"
import script from "./SubDivisionBacklog-Column.vue?vue&type=script&lang=js&"
export * from "./SubDivisionBacklog-Column.vue?vue&type=script&lang=js&"
import style0 from "./SubDivisionBacklog-Column.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports